import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IGroupItemsListResponse } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { setGroupItemsList } from "@/app_redux/reducers/slices/auth/inventory_slice";

AxiosCurlirize(axios, () => {});

export const useGroupItemsListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (pageNumber: number, pageSize: number, query: string) => {
      dispatch(
        setLoading({
          key: "isInventoryServiceListLoadingInProgess",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const searchKeywordParam = query ? `&search_keyword=${encodeURIComponent(query)}` : "";
        const res: AxiosResponse<IGroupItemsListResponse> = await axios.get(
          `${INVENTORY_MODULE?.GROUP_ITEMS_LIST?.baseURL}?page_number=${pageNumber}&page_size=${pageSize}${searchKeywordParam}`,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        if (res.data.status === true) {
          dispatch(setGroupItemsList(res?.data.data));
        } else {
          dispatch(setGroupItemsList({ results: [], total_records: 0 }));
        }
        dispatch(
          setLoading({
            key: "isInventoryServiceListLoadingInProgess",
            status: false,
          }),
        );
      } catch (error) {
        dispatch(setGroupItemsList({ results: [], total_records: 0 }));

        dispatch(
          setLoading({
            key: "isInventoryServiceListLoadingInProgess",
            status: false,
          }),
        );
        if (axios.isAxiosError(error)) {
          captureError(error);
          if (error.config) {
            sendCurl(error.config["curlCommand"]);
          }
        } else {
          toast.error("Server Error: " + (error as Error).message);
        }
      }
    },
    [dispatch, configuration, sendCurl, captureError],
  );
  return { execute };
};
